import { animate, state, style, transition, trigger } from '@angular/animations';
import { NgClass } from '@angular/common';
import { Component, input, output, OutputEmitterRef } from '@angular/core';

@Component({
  selector: 'app-mini-headband',
  standalone: true,
  imports: [NgClass],
  templateUrl: './mini-headband.component.html',
  styleUrl: './mini-headband.component.scss',
  animations: [
    trigger('toggle', [
      transition(':enter', [
        style({ transform: 'translateX(-50%) translateY(-100%)' }),
        animate('200ms ease-in', style({ transform: 'translateX(-50%) translateY(0)' })),
      ]),
      transition(':leave', [
        style({ transform: 'translateX(-50%) translateY(0)' }),
        animate('200ms ease-in', style({ transform: 'translateX(-50%) translateY(-100%)' })),
      ]),
    ]),
    trigger('textState', [
      state(
        'collapsed',
        style({
          width: '0',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }),
      ),
      state(
        'expanded',
        style({
          width: '*',
        }),
      ),
      transition('collapsed <=> expanded', [animate('500ms ease-in-out')]),
    ]),
  ],
})
export class MiniHeadbandComponent {
  toggle = input(false);
  content = input('');
  btnPrimaryText = input('');
  btnSecondaryText = input('');

  callbackBtn: OutputEmitterRef<boolean> = output();

  showFullMessage = true;

  constructor() {}

  onBtnPrimaryClick() {
    this.callbackBtn.emit(true);
  }

  onBtnSecondaryClick() {
    this.callbackBtn.emit(false);
  }

  onSvgClick() {
    this.showFullMessage = !this.showFullMessage;
  }
}
